import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { apiSubmit } from '../main';

export const apiRequestAsyncThunk = createAsyncThunk('apiRequestAsyncThunk/do',
  async ({ request_details, call, messages = { loading: 'Loading...', done: 'Loaded.', error: 'Loading failed!' } }, { rejectWithValue }) => {
    //console.log('apiRequestAsyncThunk.try', request_details);

    let response = null;

    try {

      var loading = toast.loading(messages.loading, {
        closeOnClick: true,
        closeButton: true
      });

      call && call('loading');
      response = await apiSubmit(request_details);
      //console.log('apiRequestAsyncThunk.response', response?.content);
      if (response) {
        call && call('done', response?.content);
        toast.update(loading, {
          render: messages.done,
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
      }

    } catch (error) {
      console.log('apiRequestAsyncThunk.error', error);
      response = (error.error && `${error.error.status}: ${error.error.message}`) || error.message || error;
      //console.log('response.error', response);
      call && call('error', error);
      toast.update(loading, {
        //render: messages.error,
        render:response.message || response,
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      //console.log('rejectWithValue.error', response, error);
      return rejectWithValue(error.error || error.message || error);
    }

    return response;
  }
);